import { createContext, useState } from "react";

export const SuccesContext = createContext();

const SuccesProvider = ({ children }) => {
  const [numberOfMoves, setNumberOfMoves] = useState(0);
  const [isGameWon, setIsGameWon] = useState(false);

  return (
    <SuccesContext.Provider
      value={{ numberOfMoves, setNumberOfMoves, isGameWon, setIsGameWon }}
    >
      {children}
    </SuccesContext.Provider>
  );
};

export default SuccesProvider;
